const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/stock');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  save(...parameters) {
    return gettingEntryService().then((service) => service.save(...parameters));
  },

  getByMake(makeId, depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'carInStock', // eslint-disable-line
        'sys.archivedAt[exists]': false,
        'fields.make.sys.id': makeId,
        'order': 'fields.name',
        'limit': 999
      }).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  }
};
